import {h} from 'preact';

export default function GoogleDocsIframe({tag = '', googleTracking = '', isBuy}) {
    let src =
        'https://docs.google.com/presentation/d/e/2PACX-1vSb_fusKapj8yQmFF_G50Gv8lwRy8SFwUNkRjENzYXz6tZevOIPfyqvK8RAKW5HIj-4501jUgWNBVTL/embed?start=false&loop=false&delayms=3000';
    if (tag.includes('home-value-estimator')) {
        src =
            'https://docs.google.com/presentation/d/e/2PACX-1vT68jM5tcFAm0Bg5NEDd-iWZVnD3f0NfgWhK2oG93Ajt46vanvxTMlIB-Aa0u9WK9oMHZKRw2cFb1fZ/embed?start=false&loop=false&delayms=3000';
    } else if (isBuy) {
        src =
            //'https://docs.google.com/document/d/e/2PACX-1vQSwz-OAQ2Csz2WRC-BO22kcD815CByYiRVbs368PStcGJ8YuIe3dViEyzItpvBt78B3P4KQuC_g-Ur/pub';
            'https://docs.google.com/presentation/d/1niqSW90w2-YxMe5NovRDoMu1VktBZZuuQHpqbO_Y94s/embed?start=false&loop=false&delayms=3000'
    } else if (tag.includes('commission')) {
        src =
            'https://docs.google.com/presentation/d/e/2PACX-1vRCxPaYsx_Mj_G_OT06QSL7zo5H2JpB_tP7e2Q4uQG5yxfiZFrwwmZvJqb17KoWWwFnQTi5J4abO0D7/embed?start=false&loop=false&delayms=3000';
    } else if (googleTracking.includes('homelight')) {
        src =
            'https://docs.google.com/presentation/d/e/2PACX-1vRnIudVtB8Esmj0jniczpLOBtyYWlPTC77csmvXSyE6CQHjQVwu18N4rUAt0G4LYSrNrtqGSkO_eAA0/embed?start=false&loop=false&delayms=3000';
    } else if (googleTracking.includes('redfin')) {
        src =
            'https://docs.google.com/presentation/d/e/2PACX-1vQ3pRP9G7M9jYMRmvpqucwJrC-So8u_mzkWqK6EHp2tA5uh9WyQUTNdiJy6p_wrXGO1l7UEL_um7Ro2/embed?start=false&loop=false&delayms=3000';
    } else if (googleTracking.includes('purple')) {
        src =
            'https://docs.google.com/presentation/d/e/2PACX-1vQ3pRP9G7M9jYMRmvpqucwJrC-So8u_mzkWqK6EHp2tA5uh9WyQUTNdiJy6p_wrXGO1l7UEL_um7Ro2/embed?start=false&loop=false&delayms=3000';
    } else if (googleTracking.includes('xome')) {
        src =
            'https://docs.google.com/presentation/d/e/2PACX-1vQ3pRP9G7M9jYMRmvpqucwJrC-So8u_mzkWqK6EHp2tA5uh9WyQUTNdiJy6p_wrXGO1l7UEL_um7Ro2/embed?start=false&loop=false&delayms=3000';
    } else if (googleTracking.includes('fsbo')) {
        src =
            'https://docs.google.com/presentation/d/e/2PACX-1vQqDwIN-9c-o0BOK5Itu7B0RZfQLhVFTNWdUnBSPR8yVbqpMaVpaWxKlvzwGwg5vrwIDsyDbdXqwUTd/embed?start=false&loop=false&delayms=3000';
    } else if (googleTracking.includes('owner')) {
        src =
            'https://docs.google.com/presentation/d/e/2PACX-1vQqDwIN-9c-o0BOK5Itu7B0RZfQLhVFTNWdUnBSPR8yVbqpMaVpaWxKlvzwGwg5vrwIDsyDbdXqwUTd/embed?start=false&loop=false&delayms=3000';
    }

    return (
        <div className='admin-script-container'>
            <iframe
                class='sticky-note'
                src={src}
                frameborder='0'
                width='100%'
                height='1000'
                allowfullscreen='true'
                mozallowfullscreen='true'
                webkitallowfullscreen='true'
                style='top:20px;left:100px;'
            />
        </div>
    );
}
